const CHECK_INTERVAL = 60000

export function validReleaseVersion(value) {
  return typeof value === 'string' && /^[a-z0-9]{8,16}-[a-f0-9]{12}$/.test(value)
}

export function releaseUrl(href, version) {
  const hashAt = href.indexOf('#')
  const hash = hashAt < 0 ? '' : href.slice(hashAt)
  const base = hashAt < 0 ? href : href.slice(0, hashAt)
  const queryAt = base.indexOf('?')
  const path = queryAt < 0 ? base : base.slice(0, queryAt)
  const query = queryAt < 0 ? [] : base.slice(queryAt + 1).split('&').filter(part => {
    try { return decodeURIComponent(part.split('=')[0]) !== '_appv' } catch (error) { return true }
  })
  query.push('_appv=' + encodeURIComponent(version))
  return path + '?' + query.filter(Boolean).join('&') + hash
}

// A persistent, non-blocking button lets users finish editing before updating.
export function showReleaseUpdate(version, win, doc) {
  if (doc.getElementById('app-release-update')) return
  const button = doc.createElement('button')
  button.id = 'app-release-update'
  button.type = 'button'
  button.textContent = '发现新版本，点击更新页面'
  button.setAttribute('aria-label', '发现新版本，点击更新页面；未提交的内容将清除')
  button.style.cssText = 'position:fixed;bottom:20px;left:5%;width:90%;z-index:2147483647;padding:14px;border:1px solid #167d28;border-radius:6px;background:#fff;color:#167d28;font-size:16px;box-shadow:0 2px 12px #999;'
  button.onclick = () => {
    if (win.confirm('更新将重新加载页面，未提交的内容将清除。现在更新？')) {
      win.location.replace(releaseUrl(win.location.href, version))
    }
  }
  doc.body.appendChild(button)
}

export function installReleaseVersionCheck(currentVersion, router, win = window, doc = document, notify = showReleaseUpdate) {
  if (!validReleaseVersion(currentVersion)) return
  let lastCheck = -Infinity
  let pending = false
  let notified = false
  const check = () => {
    if (pending || notified || doc.hidden || Date.now() - lastCheck < CHECK_INTERVAL) return
    lastCheck = Date.now()
    pending = true
    try {
      const xhr = new win.XMLHttpRequest()
      xhr.open('GET', '/version.json?_=' + lastCheck, true)
      xhr.timeout = 10000
      xhr.setRequestHeader('Cache-Control', 'no-cache')
      xhr.onload = () => {
        pending = false
        if (xhr.status !== 200) return
        try {
          const version = JSON.parse(xhr.responseText).version
          if (validReleaseVersion(version) && version !== currentVersion) {
            notified = true
            notify(version, win, doc)
          }
        } catch (error) { /* Invalid CDN responses must not interrupt the application. */ }
      }
      xhr.onerror = xhr.ontimeout = xhr.onabort = () => { pending = false }
      xhr.send()
    } catch (error) { pending = false }
  }
  doc.addEventListener('visibilitychange', check)
  win.addEventListener('pageshow', check)
  if (router) router.afterEach(check)
  check()
}



// WEBPACK FOOTER //
// ./src/utils/releaseVersion.js